import { render, staticRenderFns } from "./BindPhoneDialog.vue?vue&type=template&id=2c517464&scoped=true"
import script from "./BindPhoneDialog.vue?vue&type=script&lang=js"
export * from "./BindPhoneDialog.vue?vue&type=script&lang=js"
import style0 from "./BindPhoneDialog.vue?vue&type=style&index=0&id=2c517464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c517464",
  null
  
)

export default component.exports